import React, { Component } from 'react';
import gsap from 'gsap'
import { throttle } from 'lodash';

import Pagination from './Pagination'
import Slide from './Slide'

import './Carousel.css'

class Carousel extends Component {

    constructor(props) {

        super(props);

        this.state = {
            active: 0,
            slides: [],
            isAnimating: false,
            shrink: false,
            progressX: 0,
            progressY: 0
        };



        this.shrink = this.shrink.bind(this);
        this.move = this.move.bind(this);
        this.expand = this.expand.bind(this);

        this.scroll = this.scroll.bind(this);
        this.bind = this.bind.bind(this);
        this.removeBind = this.removeBind.bind(this);
        this.movement = this.movement.bind(this)
        this.switchSlide = this.switchSlide.bind(this);

        this.handleKeyboard = this.handleKeyboard.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);


    }

    movement(e) {

        const { viewport } = this.props

        const x = e.clientX
        const y = e.clientY

        const progressX = Math.ceil(x / viewport.width * 100)
        const progressY = Math.ceil(y / viewport.height * 100)

        this.setState({
            progressX,
            progressY
        })

    }


    shrink(active) {

        this.setState({
            shrink: true
        })

        window.setTimeout(() => {
            this.move(active)
        }, 750)


    }

    move(active) {

        gsap.to(this.track, {
            duration: 0.75,
            top: -100 * active + '%',
            ease: 'power4.in',
            onComplete: () => {
                this.expand(active)
            }
        })

    }

    expand(active) {

        this.setState({
            shrink: false
        })

        window.setTimeout(() => {

            this.setState({
                active
            })

            this.bind()
        }, 750)

    }




    switchSlide(active) {

        this.setState({
            isAnimating: true
        });

        this.removeBind()

        this.shrink(active)

    }

    componentDidMount() {

        this.cbMovement = throttle(this.movement)

        this.bind()
    }

    componentWillUnmount() {
        this.removeBind();
    }


    scroll(e) {

        const total = this.props.slides.length
        let active = this.state.active

        if (e.deltaY > 0) {
            if (active + 1 === total) {
                return
            }
            active += 1
        }
        else {
            if (active === 0) {
                return
            }
            active -= 1
        }

        this.switchSlide(active)

    }

    handleKeyboard(e) {

        const total = this.props.slides.length

        const code = e.code
        let active = this.state.active

        switch (code) {
            case 'ArrowDown':
                active += 1
                break
            case 'ArrowUp':
                active -= 1
                break
            default:
                return false
        }

        if (active < 0) {
            return false

        }
        if ((active + 1) > total) {
            return false
        }

        this.switchSlide(active)

    }


    bind() {
        this.setState({
            isAnimating: false
        })

        window.addEventListener('wheel', this.scroll)
        window.addEventListener('keyup', this.handleKeyboard)

        window.addEventListener('touchstart', this.handleTouchStart, false)
        window.addEventListener('touchend', this.handleTouchEnd, false)

        window.addEventListener('mousemove', this.cbMovement)

    }

    removeBind() {
        window.removeEventListener('wheel', this.scroll)
        window.removeEventListener('keyup', this.handleKeyboard)
        window.removeEventListener('touchstart', this.handleTouchStart)
        window.removeEventListener('touchend', this.handleTouchEnd)

        window.removeEventListener('mousemove', this.cbMovement)
    }

    handleTouchStart(e) {

        const { touches } = e

        if (touches.length > 0) {
            this.touchStart = touches[0].clientY
        }

    }

    handleTouchEnd(e) {

        const { changedTouches } = e
        let { active } = this.state
        const total = this.props.slides.length

        if (changedTouches.length > 0) {
            this.touchEnd = changedTouches[0].clientY
        }

        let difference = Math.max(this.touchStart, this.touchEnd) - Math.min(this.touchStart, this.touchEnd)

        if(difference < 50) {
            return false
        }




        if (this.touchStart > this.touchEnd) {
            active += 1
        }
        else {
            active -= 1
        }

        if (active < 0) {
            return false
        }
        if ((active + 1) > total) {
            return false
        }

        this.switchSlide(active)

    }


    render() {

        const { active, isAnimating, shrink, progressX, progressY } = this.state
        const { viewport, slides } = this.props

        return (

            <div className="carousel" ref={(carousel) => { this.carousel = carousel }} role="region" aria-label="Featured projects carousel" tabIndex="0">

                <h2 className='carousel__title'>Featured Projects</h2>
                
                <div className="carousel-instructions sr-only">
                    Use arrow keys to navigate through slides, or scroll vertically to change slides.
                </div>

                <div 
                    className="track" 
                    ref={(track) => { this.track = track }}
                    role="tabpanel"
                    aria-label={`Slide ${active + 1} of ${slides.length}`}
                    aria-live="polite"
                >

                    {slides.map((slide, index) => {

                        const isActive = active === index ? true : false

                        return <Slide key={index} {...slide} index={index} shrink={shrink} isAnimating={isAnimating} isActive={isActive}
                            viewport={viewport}
                            progressX={progressX}
                            progressY={progressY}
                        />

                    })}

                </div>


                <Pagination slides={slides} active={active} switchSlide={this.switchSlide} />

            </div>

        );
    }
}

export default Carousel;
